(function(){
  var F = {"standard":"Fan Version","pro":"Player Version"};

  function applyToEl(el){
    if (el.getAttribute('data-fit-applied') === '1') return;
    var code = el.getAttribute('data-fit');
    if (code && F[code]) {
      el.textContent = F[code];
      el.setAttribute('data-fit-applied','1');
    }
  }

  function applyAll(root){
    (root || document).querySelectorAll('[data-fit]:not([data-fit-applied])').forEach(applyToEl);
  }

  // Substituicoes literais em text nodes (usado nos templates JSON onde o
  // sanitizer da Shopify nao permite span com atributos custom).
  var TXTSUBS = [
    { re: /\bStandard version:/g, pra: 'Fan version:' },
    { re: /\bPro version:/g, pra: 'Player version:' },
    { re: /\bStandard and Pro versions\b/g, pra: 'Fan and Player versions' },
    { re: /\bthe Standard version\b/g, pra: 'the Fan version' },
    { re: /\bthe Pro version\b/g, pra: 'the Player version' },
    { re: /\bThe Standard version\b/g, pra: 'The Fan version' },
    { re: /\bThe Pro version\b/g, pra: 'The Player version' },
    { re: /\bAttention: Pro \(Slim Fit\)/g, pra: 'Attention: Player Version (Slim Fit)' },
    { re: /\bIf you go for the Pro\b/g, pra: 'If you go for the Player Version' }
  ];

  function scanTexts(root){
    try {
      var w = document.createTreeWalker(root || document.body, NodeFilter.SHOW_TEXT, null, false);
      var n, nodes = [];
      while (n = w.nextNode()) nodes.push(n);
      for (var i=0; i<nodes.length; i++){
        var t = nodes[i].nodeValue;
        if (!t || t.length < 3) continue;
        var ini = t;
        for (var j=0; j<TXTSUBS.length; j++){
          if (TXTSUBS[j].re.test(t)) { TXTSUBS[j].re.lastIndex = 0; t = t.replace(TXTSUBS[j].re, TXTSUBS[j].pra); }
        }
        if (t !== ini) nodes[i].nodeValue = t;
      }
    } catch(e) {}
  }

  function go(){ applyAll(); scanTexts(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go);
  else go();

  var obs = new MutationObserver(function(muts){
    for (var i=0; i<muts.length; i++){
      var m = muts[i];
      for (var j=0; j<m.addedNodes.length; j++){
        var n = m.addedNodes[j];
        if (n.nodeType !== 1) continue;
        if (n.hasAttribute && n.hasAttribute('data-fit')) applyToEl(n);
        if (n.querySelectorAll) applyAll(n);
        scanTexts(n);
      }
    }
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
